import { useGame } from '../state/gameContext';
import { Link } from 'react-router-dom';
import { PlayerAvatar } from './PlayerAvatar';
import { GameMenu } from './game/GameMenu';

interface TopNavProps {
  /** Show the chat button (only useful inside an active room). */
  showChat?: boolean;
}

export function TopNav({ showChat = false }: TopNavProps) {
  const { currentPlayer } = useGame();
  return (
    <nav className="fixed top-0 w-full z-50 flex justify-between items-center px-margin-mobile md:px-margin-desktop h-16 bg-surface/80 backdrop-blur-xl border-b border-white/10 shadow-sm">
      <Link
        to="/"
        className="font-headline-md-mobile text-lg sm:text-headline-md-mobile font-black text-primary italic tracking-tighter"
      >
        Deck After Dark
      </Link>
      <div className="flex items-center gap-stack-md">
        <GameMenu showChat={showChat} showLeave />
        <PlayerAvatar
          initials={currentPlayer?.initials ?? 'YO'}
          gradient={currentPlayer?.gradient ?? 'from-primary-container to-primary/60'}
          size="sm"
          alt={currentPlayer ? `${currentPlayer.name} avatar` : 'Your avatar'}
          className="border border-primary/30"
        />
      </div>
    </nav>
  );
}
